(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1241],{

/***/ 17198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CallToActionBanner_CallToActionBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./components/CallToActionBanner/CallToActionBanner.module.scss
var CallToActionBanner_module = __webpack_require__(1357);
var CallToActionBanner_module_default = /*#__PURE__*/__webpack_require__.n(CallToActionBanner_module);
;// CONCATENATED MODULE: ./components/CallToActionBanner/CallToActionBannerBg.tsx

var CallToActionBannerBg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 154 155",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.4684 62.5L107.2 35.3287C108.314 32.4797 108.263 29.3054 107.057 26.4941C105.851 23.6828 103.589 21.4611 100.76 20.3107C100.589 20.24 100.414 20.1807 100.236 20.1331C99.7333 19.9494 99.2184 19.8023 98.6948 19.693C98.4098 19.639 98.1324 19.6081 97.8474 19.5772H97.7087C97.3098 19.5299 96.9086 19.5042 96.5069 19.5C96.0972 19.5038 95.6882 19.5322 95.2819 19.5849H95.1741C94.889 19.5849 94.604 19.6467 94.3035 19.7008C93.7798 19.8094 93.2648 19.9565 92.7627 20.1409C92.5855 20.1949 92.416 20.249 92.2157 20.3262C89.3939 21.4826 87.1392 23.7051 85.9385 26.5135C84.7377 29.322 84.6873 32.4911 85.7982 35.3364L96.4684 62.5Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.4947 62.5L64.202 35.3287C65.3134 32.4797 65.2621 29.3054 64.0592 26.4941C62.8563 23.6828 60.5988 21.4611 57.7761 20.3107C57.6081 20.2411 57.4362 20.1818 57.2611 20.1331C56.7444 19.9485 56.2153 19.8014 55.6776 19.693C55.4009 19.639 55.1165 19.6081 54.8321 19.5772H54.6938C54.2957 19.5299 53.8955 19.5042 53.4947 19.5C53.086 19.5038 52.6779 19.5322 52.2725 19.5849H52.1649C51.8805 19.5849 51.5961 19.6467 51.304 19.7008C50.7814 19.8088 50.2675 19.9559 49.7667 20.1409C49.5976 20.1949 49.4208 20.249 49.221 20.3262C46.4007 21.475 44.1447 23.694 42.9419 26.5022C41.739 29.3104 41.6863 32.4817 42.7951 35.3287L53.4947 62.5Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.5092 92.5L85.7976 119.659C84.6859 122.509 84.7381 125.685 85.9429 128.497C87.1477 131.309 89.408 133.531 92.2338 134.682C92.3953 134.743 92.5645 134.805 92.749 134.859C93.2659 135.044 93.7953 135.191 94.3331 135.299C94.6099 135.353 94.8944 135.384 95.1789 135.415H95.2866C96.1004 135.528 96.9258 135.528 97.7396 135.415H97.8472C98.1318 135.415 98.4086 135.353 98.7085 135.292C99.231 135.186 99.7451 135.041 100.246 134.859C100.423 134.805 100.608 134.743 100.8 134.666C103.618 133.512 105.869 131.289 107.067 128.481C108.264 125.672 108.311 122.502 107.198 119.659L96.5092 92.5Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.5059 92.5L42.7989 119.659C41.6864 122.508 41.7376 125.683 42.9412 128.495C44.1449 131.307 46.4041 133.53 49.2293 134.682C49.3908 134.743 49.56 134.805 49.7446 134.859C50.2616 135.044 50.7912 135.191 51.3291 135.299C51.6061 135.353 51.8906 135.384 52.1752 135.415H52.2906C52.6965 135.465 53.1047 135.494 53.5136 135.5C53.9225 135.493 54.3307 135.465 54.7366 135.415H54.8443C55.1334 135.389 55.4209 135.347 55.7058 135.292C56.2285 135.186 56.7427 135.041 57.2442 134.859C57.4211 134.805 57.6057 134.743 57.798 134.666C60.6165 133.512 62.8685 131.289 64.0663 128.481C65.2641 125.672 65.3112 122.502 64.1976 119.659L53.5059 92.5Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M124.529 89.053C130.528 86.5682 133.377 79.6907 130.892 73.6918C128.407 67.6928 121.53 64.8441 115.531 67.3289C109.532 69.8138 106.683 76.6912 109.168 82.6902C111.653 88.6891 118.53 91.5378 124.529 89.053Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M75 89.5C81.6274 89.5 87 84.3513 87 78C87 71.6487 81.6274 66.5 75 66.5C68.3726 66.5 63 71.6487 63 78C63 84.3513 68.3726 89.5 75 89.5Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.0078 66.5C27.6338 66.4985 25.3126 67.1719 23.338 68.435C21.3634 69.698 19.8242 71.494 18.9149 73.5957C18.0057 75.6973 17.7674 78.0102 18.2302 80.2417C18.693 82.4732 19.836 84.523 21.5147 86.1317C23.1934 87.7405 25.3323 88.8359 27.6608 89.2794C29.9893 89.7229 32.4028 89.4945 34.5958 88.6232C36.7888 87.7518 38.6629 86.2767 39.9809 84.3844C41.2989 82.4921 42.0015 80.2676 42 77.9925C41.9959 74.9457 40.7311 72.0249 38.483 69.8705C36.2349 67.7161 33.1871 66.504 30.0078 66.5V66.5Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var CallToActionBanner_CallToActionBannerBg = (CallToActionBannerBg);

;// CONCATENATED MODULE: ./components/CallToActionBanner/CallToActionBanner.tsx








function CallToActionBanner(props) {
    var heading = props.heading, body = props.body, primaryCtaText = props.primaryCtaText, primaryCtaHref = props.primaryCtaHref, _onPrimaryCtaClick = props.onPrimaryCtaClick, onPrimaryCtaClick = _onPrimaryCtaClick === void 0 ? function() {
        return null;
    } : _onPrimaryCtaClick, secondaryCtaText = props.secondaryCtaText, secondaryCtaHref = props.secondaryCtaHref, _onSecondaryCtaClick = props.onSecondaryCtaClick, onSecondaryCtaClick = _onSecondaryCtaClick === void 0 ? function() {
        return null;
    } : _onSecondaryCtaClick, dataTestId = props.dataTestId, className = props.className, _withLogo = props.withLogo, withLogo = _withLogo === void 0 ? false : _withLogo, primaryButtonClassName = props.primaryButtonClassName;
    var isHeadingOnlyWithAction = heading && !body && primaryCtaText;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var trackCtaClick = function(callback) {
        return function() {
            if ("trackingEvent" in props) {
                track(props.trackingEvent, props.trackingDetails);
            }
            callback();
        };
    };
    var primaryCta = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        variant: "contained",
        href: primaryCtaHref,
        onClick: trackCtaClick(onPrimaryCtaClick),
        className: classnames_default()((CallToActionBanner_module_default()).primary, primaryButtonClassName),
        size: "large",
        "data-testid": "cta-banner-primary-button",
        children: primaryCtaText
    });
    var secondaryCta = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        href: secondaryCtaHref,
        onClick: trackCtaClick(onSecondaryCtaClick),
        className: (CallToActionBanner_module_default()).secondary,
        size: "large",
        "data-testid": "cta-banner-secondary-button",
        children: secondaryCtaText
    });
    var wrapWithLink = function(content, href) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            prefetch: false,
            href: href,
            as: href,
            passHref: true,
            children: content
        });
    };
    var bodyContent = body && typeof body === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: body
    }) : body;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: classnames_default()((CallToActionBanner_module_default()).container, className),
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((CallToActionBanner_module_default()).subContainer, isHeadingOnlyWithAction && (CallToActionBanner_module_default()).twoColumn),
                children: [
                    heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (CallToActionBanner_module_default()).heading,
                        "data-testid": "cta-banner-heading-text",
                        children: heading
                    }),
                    body && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CallToActionBanner_module_default()).body,
                        "data-testid": "cta-banner-body-text",
                        children: bodyContent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CallToActionBanner_module_default()).actions,
                        children: [
                            primaryCtaText && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: primaryCtaHref ? wrapWithLink(primaryCta, primaryCtaHref) : primaryCta
                            }),
                            secondaryCtaText && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: secondaryCtaHref ? wrapWithLink(secondaryCta, secondaryCtaHref) : secondaryCta
                            })
                        ]
                    })
                ]
            }),
            withLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "aria-hidden": true,
                className: (CallToActionBanner_module_default()).bgImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActionBanner_CallToActionBannerBg, {})
            })
        ]
    });
}
/* harmony default export */ var CallToActionBanner_CallToActionBanner = (CallToActionBanner);

;// CONCATENATED MODULE: ./components/CallToActionBanner/index.tsx



/***/ }),

/***/ 12042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ JobApplicationStatusLabel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25073);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var JobApplicationStatusLabel = function(param) {
    var status = param.status;
    if (status === "successful") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().status), (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[status]),
            "data-testid": "job-application-status-label",
            children: "APPLICATION ACCEPTED"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().status), (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[status]),
        "data-testid": "job-application-status-label",
        children: status.toUpperCase()
    });
};


/***/ }),

/***/ 91632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ JobButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _app_utils_urlHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52484);
/* harmony import */ var _modules_Context_useAuth0User__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65200);
/* harmony import */ var constants_path__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96703);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_useAnalytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9800);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(282);









var JobButton = function(param) {
    var id = param.id, jobNumber = param.jobNumber, _text = param.text, text = _text === void 0 ? "Enquire" : _text, url = param.url, trackingCallback = param.trackingCallback, _buttonSize = param.buttonSize, buttonSize = _buttonSize === void 0 ? "large" : _buttonSize, className = param.className, addJobNumberQueryParam = param.addJobNumberQueryParam, disableEnquireAndWithdrawButtons = param.disableEnquireAndWithdrawButtons;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var track = (0,utils_useAnalytics__WEBPACK_IMPORTED_MODULE_5__/* .useAnalytics */ .z)();
    var user = (0,_modules_Context_useAuth0User__WEBPACK_IMPORTED_MODULE_2__/* .useAuth0User */ .a)().user;
    var isDisabled = disableEnquireAndWithdrawButtons && text === "Enquire" && !!user;
    var defaultTrackingCallback = function() {
        if (disableEnquireAndWithdrawButtons && text === "Register") {
            track("Register button clicked", {
                jobNumber: jobNumber
            });
            return;
        }
        track("Job Enquire", {
            jobNumber: jobNumber
        });
    };
    trackingCallback = trackingCallback !== null && trackingCallback !== void 0 ? trackingCallback : defaultTrackingCallback;
    // TODO: Tidy up this function - bit all over the place
    var onClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var redirectUrl;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                trackingCallback && trackingCallback();
                if (text === "See Details") {
                    url ? router.push(url) : router.push("/jobs/".concat(id));
                } else if (text === "Register") {
                    router.push(constants_path__WEBPACK_IMPORTED_MODULE_3__/* .PATH.REGISTER */ .m.REGISTER);
                } else if (user) {
                    router.push("".concat(url).concat(constants_path__WEBPACK_IMPORTED_MODULE_3__/* .PATH.JOB_ENQUIRE */ .m.JOB_ENQUIRE));
                } else {
                    redirectUrl = addJobNumberQueryParam ? (0,_app_utils_urlHelper__WEBPACK_IMPORTED_MODULE_1__/* .getRegisterUrlClientSideWithJobNumber */ .ZH)(jobNumber, "".concat(url).concat(constants_path__WEBPACK_IMPORTED_MODULE_3__/* .PATH.JOB_ENQUIRE */ .m.JOB_ENQUIRE), url) : (0,_app_utils_urlHelper__WEBPACK_IMPORTED_MODULE_1__/* .getRegisterUrlClientSide */ .SE)("enquire_job", "".concat(url).concat(constants_path__WEBPACK_IMPORTED_MODULE_3__/* .PATH.JOB_ENQUIRE */ .m.JOB_ENQUIRE));
                    router.push(redirectUrl);
                }
                return [
                    2
                ];
            });
        });
        return function onClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: className,
        fullWidth: true,
        variant: "contained",
        size: buttonSize,
        color: "secondary",
        onClick: onClick,
        "data-testid": "job-button",
        disabled: isDisabled,
        children: text
    });
};


/***/ }),

/***/ 76242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ JobFavouriteButton_JobFavouriteButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/urlHelper.ts
var urlHelper = __webpack_require__(52484);
// EXTERNAL MODULE: ./modules/Context/useAuth0User.tsx
var useAuth0User = __webpack_require__(65200);
// EXTERNAL MODULE: ./utils/clientErrorInfo.ts
var clientErrorInfo = __webpack_require__(54787);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./utils/useGoogleAnalytics.ts


var useGoogleAnalytics = function() {
    return (0,react.useCallback)(function(eventName, eventDetails) {
        var gtag =  true ? window === null || window === void 0 ? void 0 : window.gtag : 0;
        if (!gtag) {
            return;
        }
        try {
            gtag("event", eventName, eventDetails);
        } catch (e) {
            // Just push these errors into Sentry, we can't respond to them in any useful way.
            (0,clientErrorInfo.tryToNoticeClientError)(e);
        }
    }, []);
};

// EXTERNAL MODULE: ./utils/useRequest.ts
var useRequest = __webpack_require__(87243);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Check.js
var Check = __webpack_require__(41959);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Star.js
var Star = __webpack_require__(85984);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/StarBorder.js
var StarBorder = __webpack_require__(83817);
// EXTERNAL MODULE: ./modules/JobFavouriteButton/style.module.scss
var style_module = __webpack_require__(14905);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./modules/JobFavouriteButton/JobFavouriteButton.tsx



















var JobFavouriteButton = function(param) {
    var id = param.id, jobNumber = param.jobNumber, style = param.style, _favourited = param.favourited, favourited = _favourited === void 0 ? false : _favourited, _showText = param.showText, showText = _showText === void 0 ? true : _showText;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var trackGA = useGoogleAnalytics();
    var router = (0,next_router.useRouter)();
    var user = (0,useAuth0User/* useAuth0User */.a)().user;
    var ref = (0,react.useState)(favourited), favourite = ref[0], setFavourite = ref[1];
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(true), showButtonText = ref2[0], setShowButtonText = ref2[1];
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("xs"));
    var isSaveAfterLogin = function() {
        return !!user && (router === null || router === void 0 ? void 0 : router.query.saveJobId) && id === router.query.saveJobId;
    };
    var handleSaveJobIdQueryParam = function() {
        var query = (0,_object_spread/* default */.Z)({}, router.query);
        delete query.saveJobId;
        router.push({
            pathname: router.pathname,
            query: query
        });
    };
    var getRedirectUrlForSaveJob = function() {
        return router.asPath.indexOf("?") !== -1 ? "".concat(router.asPath, "&saveJobId=").concat(id) : "".concat(router.asPath, "?saveJobId=").concat(id);
    };
    var toggleFavourite = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        trackGA("click_save_job", {});
                        if (!user) {
                            router.push((0,urlHelper/* getRegisterUrlClientSide */.SE)("save_job", getRedirectUrlForSaveJob()));
                            // there is a little blip in the UI where the favourited job is toggled before redirect. This prevents that.
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        if (!favourite) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,useRequest/* deleteFavoriteJob */.AJ)(id)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            (0,useRequest/* addFavoriteJob */.gL)(id)
                        ];
                    case 4:
                        _state.sent();
                        track("Job Saved", {
                            jobNumber: jobNumber
                        });
                        _state.label = 5;
                    case 5:
                        setFavourite(!favourite);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        (0,clientErrorInfo.tryToNoticeClientError)(error);
                        setError(error.message);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleFavourite() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        // Only need to addFavouriteJob as you cannot unsave from a non-loggedin state
        var addFavourite = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(isSaveAfterLogin() && !favourite)) return [
                                3,
                                5
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0,useRequest/* addFavoriteJob */.gL)(router.query.saveJobId)
                            ];
                        case 2:
                            _state.sent();
                            setFavourite(true);
                            handleSaveJobIdQueryParam();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            (0,clientErrorInfo.tryToNoticeClientError)(error);
                            setError(error.message);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                3,
                                6
                            ];
                        case 5:
                            if (isSaveAfterLogin() && favourite) {
                                handleSaveJobIdQueryParam();
                            }
                            _state.label = 6;
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function addFavourite() {
                return _ref.apply(this, arguments);
            };
        }();
        addFavourite();
    }, [
        isSaveAfterLogin,
        favourite
    ]);
    (0,react.useEffect)(function() {
        if (isMobile || !showText) {
            setShowButtonText(false);
        } else {
            setShowButtonText(true);
        }
    }, [
        isMobile,
        showText
    ]);
    var isOutlined = style === "outlined";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isOutlined && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (style_module_default()).button,
                fullWidth: true,
                variant: "outlined",
                size: "large",
                color: "secondary",
                onClick: toggleFavourite,
                "data-testid": "job-favourite-button",
                startIcon: favourite && /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {}),
                children: favourite ? "Saved" : "Save"
            }),
            !isOutlined && favourite && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {}),
                className: (style_module_default()).saveButton,
                color: "primary",
                "data-testid": "job-favourite-button",
                onClick: toggleFavourite,
                children: showButtonText ? "JOB SAVED" : null
            }),
            !isOutlined && !favourite && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarBorder/* default */.Z, {}),
                className: (style_module_default()).saveButton,
                color: "primary",
                "data-testid": "job-favourite-button",
                onClick: toggleFavourite,
                children: showButtonText ? "SAVE JOB" : null
            })
        ]
    });
};
/* harmony default export */ var JobFavouriteButton_JobFavouriteButton = (JobFavouriteButton);

;// CONCATENATED MODULE: ./modules/JobFavouriteButton/index.tsx



/***/ }),

/***/ 51241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ JobListingJobCardList_JobListingJobCardList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/JobApplicationStatusLabel/index.tsx
var JobApplicationStatusLabel = __webpack_require__(12042);
// EXTERNAL MODULE: ./modules/JobButton/index.tsx
var JobButton = __webpack_require__(91632);
// EXTERNAL MODULE: ./modules/JobCard/index.tsx + 1 modules
var JobCard = __webpack_require__(59771);
// EXTERNAL MODULE: ./modules/JobFavouriteButton/index.tsx + 2 modules
var JobFavouriteButton = __webpack_require__(76242);
// EXTERNAL MODULE: ./utils/jobListingHelper.ts
var jobListingHelper = __webpack_require__(92628);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./modules/JobListingJobCardList/components/JobListingJobCard/JobListingJobCard.tsx








var JobListingJobCard = function(param) {
    var job = param.job, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var subspcialityOrSpeciality = job.subspeciality ? job.subspeciality : job.speciality;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobCard/* default */.Z, {
        topButtonElement: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: !job.appliedStatus && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobFavouriteButton/* default */.Z, {
                id: job.id,
                jobNumber: job.jobNumber,
                favourited: job.isSaved,
                style: null
            })
        }),
        bottomButtonElement: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: job.appliedStatus ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobApplicationStatusLabel/* JobApplicationStatusLabel */.h, {
                status: job.appliedStatus
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(JobButton/* JobButton */.E, {
                buttonSize: "medium",
                id: job.id,
                jobNumber: job.jobNumber,
                url: (0,jobListingHelper/* generateJobDetailsURL */.wZ)(job.jobNumber, job.grade, subspcialityOrSpeciality),
                text: "See Details",
                trackingCallback: function() {
                    track("Job Details", {
                        "Details Origin": "Job Card",
                        "Details Action": "Button",
                        jobNumber: job.jobNumber
                    });
                }
            })
        }),
        data: job,
        isJobSummary: true,
        isHighlighted: isHighlighted
    });
};
/* harmony default export */ var JobListingJobCard_JobListingJobCard = (JobListingJobCard);

// EXTERNAL MODULE: ./components/CallToActionBanner/index.tsx + 2 modules
var CallToActionBanner = __webpack_require__(17198);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./modules/JobListingRegisterCtaBanner/JobListingRegisterCtaBanner.module.scss
var JobListingRegisterCtaBanner_module = __webpack_require__(12286);
var JobListingRegisterCtaBanner_module_default = /*#__PURE__*/__webpack_require__.n(JobListingRegisterCtaBanner_module);
;// CONCATENATED MODULE: ./modules/JobListingRegisterCtaBanner/JobListingRegisterCtaBanner.tsx





var JobListingRegisterCtaBanner = function(props) {
    if (props.suppressCTABanner) {
        return null;
    }
    var isUserLoggedIn = props.isUserLoggedIn, position = props.position, query = props.query;
    if (isUserLoggedIn) {
        return null;
    }
    var _grade, _speciality;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActionBanner/* default */.Z, {
        heading: "Access our free service, designed to save you time",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Job searching is done for you"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Get told about jobs before they hit the market"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Travel and accommodation organized and paid for"
                })
            ]
        }),
        primaryCtaText: "REGISTER",
        primaryCtaHref: path/* PATH.REGISTER */.m.REGISTER,
        className: (JobListingRegisterCtaBanner_module_default()).ctaBanner,
        dataTestId: "job-list-register-cta",
        withLogo: true,
        trackingEvent: "Job Search Register CTA click",
        trackingDetails: {
            position: position,
            grade: (_grade = query.grade) !== null && _grade !== void 0 ? _grade : "none",
            speciality: (_speciality = query.speciality) !== null && _speciality !== void 0 ? _speciality : "none"
        }
    });
};
/* harmony default export */ var JobListingRegisterCtaBanner_JobListingRegisterCtaBanner = (JobListingRegisterCtaBanner);

;// CONCATENATED MODULE: ./modules/JobListingRegisterCtaBanner/index.tsx


;// CONCATENATED MODULE: ./utils/getRandomInt.ts
var getRandomIntInclusive = function(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min); // The maximum is inclusive and the minimum is inclusive
};

;// CONCATENATED MODULE: ./modules/JobListingJobCardList/components/JobListingJobCardList/JobListingJobCardList.tsx





var JobListingJobCardList = function(props) {
    var jobs = props.jobs, suppressCTABanner = props.suppressCTABanner;
    // get a random job card index from 1 to 5
    // which would allow insert the banner to a position from 3 to 7
    var randomIndex = getRandomIntInclusive(1, 5);
    // make sure the banner is always shown when the job list is shorter than random index
    var bannerIndex = jobs.length - 1 < randomIndex || (props === null || props === void 0 ? void 0 : props.ctaPosition) === "bottom" ? jobs.length - 1 : randomIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: jobs.map(function(job, index) {
            var _isHighlighted;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobListingJobCard_JobListingJobCard, {
                        job: job,
                        isHighlighted: (_isHighlighted = props.isHighlighted) !== null && _isHighlighted !== void 0 ? _isHighlighted : false
                    }),
                    index === bannerIndex && (suppressCTABanner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobListingRegisterCtaBanner_JobListingRegisterCtaBanner, {
                        suppressCTABanner: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(JobListingRegisterCtaBanner_JobListingRegisterCtaBanner, {
                        isUserLoggedIn: props.isUserLoggedIn,
                        position: bannerIndex + 2,
                        query: props.query
                    }))
                ]
            }, job.id);
        })
    });
};
/* harmony default export */ var JobListingJobCardList_JobListingJobCardList = (JobListingJobCardList);

;// CONCATENATED MODULE: ./modules/JobListingJobCardList/index.tsx



/***/ }),

/***/ 1357:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CallToActionBanner_container__3ND3W","subContainer":"CallToActionBanner_subContainer__UYGqH","twoColumn":"CallToActionBanner_twoColumn__K75vc","actions":"CallToActionBanner_actions__puCVq","bgImage":"CallToActionBanner_bgImage__7a83S","heading":"CallToActionBanner_heading__cZVia","body":"CallToActionBanner_body__AHNjj","primary":"CallToActionBanner_primary__BzviF","secondary":"CallToActionBanner_secondary__Oifbl"};

/***/ }),

/***/ 25073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"status":"style_status__7Gv80","pending":"style_pending__XfIWJ","successful":"style_successful__6ks9J","unsuccessful":"style_unsuccessful__Xagi0","withdraw":"style_withdraw__0PE3e"};

/***/ }),

/***/ 14905:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__rdOvl","saveButton":"style_saveButton__vB5sL","saveButtonText":"style_saveButtonText__2U5Y5"};

/***/ }),

/***/ 12286:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaBanner":"JobListingRegisterCtaBanner_ctaBanner__KZFx2"};

/***/ })

}]);